/* Carriely – productpagina: varianten, galerij per kleur, sticky koopbalk, zoom */
(() => {
  'use strict';
  const UI = window.CarrielyUI;
  if (!UI) return;
  const { $, $$, money, priceHTML, layers } = UI;
  const S = (window.Carriely && window.Carriely.strings) || {};

  // Kleurnamen zoals ze in alt-teksten van foto's kunnen voorkomen (NL en EN).
  const WORDS = {
    zwart: ['zwart', 'black'], wit: ['wit', 'white'], 'crème': ['crème', 'creme', 'cream', 'ivory', 'ivoor'],
    beige: ['beige', 'sand', 'zand'], taupe: ['taupe', 'etoupe'], cognac: ['cognac', 'caramel', 'camel', 'tan'],
    koffiebruin: ['koffiebruin', 'coffee'], bruin: ['bruin', 'brown'], donkerbruin: ['donkerbruin', 'dark brown'],
    chocolade: ['chocolade', 'chocolate'], roodbruin: ['roodbruin', 'reddish brown', 'red brown'], rood: ['rood', 'red'],
    bordeaux: ['bordeaux', 'burgundy', 'wine red', 'wijnrood'], roze: ['roze', 'pink'], oudroze: ['oudroze', 'dusty pink', 'old pink'],
    groen: ['groen', 'green'], donkergroen: ['donkergroen', 'dark green', 'forest green'], kaki: ['kaki', 'khaki'],
    limoengeel: ['limoengeel', 'lime', 'yellow', 'geel'], blauw: ['blauw', 'blue'], grijs: ['grijs', 'grey', 'gray'],
    black: ['black', 'zwart'], grey: ['grey', 'gray', 'grijs'], green: ['green', 'groen'], pink: ['pink', 'roze'],
    navy: ['navy', 'marineblauw'], red: ['red', 'rood'], 'sky blue': ['sky blue', 'light blue', 'lichtblauw'], ivory: ['ivory', 'ivoor', 'cream']
  };
  // Vaste fotoset per kleur: alt eindigt op een van deze opnames.
  const SET = /, (gedragen|in de hand|schuin van voren|van dichtbij|op tafel)$/;
  const RANK = ['gedragen', 'in de hand', 'schuin van voren', 'van dichtbij', 'op tafel'];
  const rank = (s) => { const m = (s.dataset.alt || '').match(SET); return m ? RANK.indexOf(m[1]) : 9; };
  const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  function mentions(alt, entries) {
    let text = ` ${alt} `;
    const found = new Set();
    entries.forEach(({ color, word }) => {
      const re = new RegExp(`(^|[^a-zà-ÿ])${esc(word)}(?=[^a-zà-ÿ]|$)`, 'g');
      if (re.test(text)) { found.add(color); text = text.replace(re, '$1#'); }
    });
    return found;
  }

  class Product {
    constructor(root) {
      const json = $('[data-product-json]', root);
      if (!json) return;
      this.root = root;
      this.data = JSON.parse(json.textContent);
      this.form = $('form[data-product-form]', root);
      this.idInput = this.form ? $('input[name="id"]', this.form) : null;
      this.gallery = $('[data-gallery]', root);
      this.track = $('[data-track]', root);
      this.thumbs = $('[data-thumbs]', root);
      this.counter = $('[data-counter]', root);
      this.sticky = $('[data-sticky-buy]', root);
      this.slides = $$('[data-slide]', root);
      this.index = 0;
      this.visible = this.slides.slice();
      const id = this.idInput ? Number(this.idInput.value) : 0;
      this.current = this.data.variants.find((v) => v.id === id) || null;
      this.prepare();
      this.bind();
      this.filter(true);
      this.availability();
      this.initSticky();
    }
    prepare() {
      const entries = [];
      (this.data.colors || []).forEach((value) => {
        const key = String(value).toLowerCase();
        const words = WORDS[key] || [key];
        words.forEach((word) => entries.push({ color: key, word }));
        if (!words.includes(key)) entries.push({ color: key, word: key });
      });
      entries.sort((a, b) => b.word.length - a.word.length);
      this.labels = {};
      $$('[data-option-input]', this.root).forEach((i) => { this.labels[i.value.toLowerCase()] = i.dataset.label || i.value; });
      this.slides.forEach((s) => {
        s._colors = s.dataset.kind === 'variant'
          ? new Set((s.dataset.colors || '').split('|').filter(Boolean))
          : (entries.length ? mentions(s.dataset.alt || '', entries) : new Set());
        if (this.thumbs) {
          const b = document.createElement('button');
          b.type = 'button'; b.className = 'gallery__thumb'; b.dataset.thumb = s.dataset.mediaId;
          b.setAttribute('aria-label', 'Toon deze afbeelding');
          b.innerHTML = `<img src="${s.dataset.thumbSrc}" alt="" width="76" height="95" decoding="async">`;
          s._thumb = b; this.thumbs.appendChild(b);
        }
      });
    }
    bind() {
      this.root.addEventListener('change', (e) => {
        if (e.target.matches('[data-option-input]')) this.onChange();
        if (e.target.matches('[data-bundle-input]')) {
          const q = this.form && $('[data-qty-input]', this.form);
          if (q) q.value = e.target.value;
        }
      });
      const prev = $('[data-gallery-prev]', this.root);
      const next = $('[data-gallery-next]', this.root);
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));
      if (this.thumbs) this.thumbs.addEventListener('click', (e) => {
        const t = e.target.closest('[data-thumb]');
        if (!t) return;
        const i = this.visible.findIndex((s) => s.dataset.mediaId === t.dataset.thumb);
        if (i > -1) this.go(i);
      });
      if (this.track) {
        this.track.addEventListener('scroll', () => {
          const i = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
          if (i !== this.index) this.active(i);
        }, { passive: true });
        this.track.addEventListener('click', (e) => {
          const s = e.target.closest('[data-slide]');
          if (s) lightbox(this.visible, this.visible.indexOf(s));
        });
      }
    }
    selectedColor() {
      if (this.data.colorIndex < 0) return null;
      const fs = $(`[data-option-index="${this.data.colorIndex}"]`, this.root);
      const c = fs ? $('input:checked', fs) : null;
      if (c) return c.value.toLowerCase();
      return this.current ? String(this.current.options[this.data.colorIndex]).toLowerCase() : null;
    }
    // Meerdere kleuren: alleen de foto van de gekozen variant, plus sfeerfoto's die in hun alt-tekst
    // precies die kleur noemen. Foto's van andere kleuren, "alle kleuren"-foto's en infobeelden blijven weg.
    // Eén kleur (of geen kleurkeuze): alle foto's, met de variantfoto voorop.
    filter(initial) {
      if (!this.track || !this.slides.length) return;
      const multi = (this.data.colors || []).length > 1;
      const color = multi ? this.selectedColor() : null;
      const leadId = this.current && this.current.media ? String(this.current.media) : null;
      const lead = []; const mine = []; const neutral = []; const info = [];
      this.slides.forEach((s) => {
        const kind = s.dataset.kind;
        if (color) {
          if (kind === 'variant') { if (s._colors.has(color) || s.dataset.mediaId === leadId) lead.push(s); }
          else if (s._colors.has(color)) mine.push(s);
          return;
        }
        if (kind === 'variant') lead.push(s);
        else if (kind === 'info') info.push(s);
        else neutral.push(s);
      });
      lead.sort((a, b) => (b.dataset.mediaId === leadId) - (a.dataset.mediaId === leadId));
      // Vaste fotoset per kleur (alt "Naam, kleur, gedragen" enz.): dan alleen variantfoto + die set, in vaste volgorde.
      const pool = color ? mine : [...neutral, ...info];
      const set = pool.filter((s) => SET.test(s.dataset.alt || ''));
      if (set.length) {
        set.sort((a, b) => rank(a) - rank(b));
        if (!color) lead.splice(1);
        let order0 = [...lead, ...set];
        this.apply(order0, initial);
        return;
      }
      let order = [...lead, ...mine, ...neutral, ...info];
      if (!order.length) order = this.slides.slice();
      this.apply(order, initial);
    }
    apply(order, initial) {
      const shown = new Set(order);
      this.slides.forEach((s) => {
        s.hidden = !shown.has(s);
        if (s._thumb) s._thumb.hidden = s.hidden;
      });
      order.forEach((s, i) => {
        s.classList.toggle('is-lead', i === 0);
        s.classList.toggle('is-wide', i > 0 && i === order.length - 1 && (order.length - 1) % 2 === 1);
        this.track.appendChild(s);
        if (s._thumb && this.thumbs) this.thumbs.appendChild(s._thumb);
      });
      this.visible = order;
      if (this.gallery) {
        this.gallery.classList.toggle('gallery--single', order.length === 1);
        this.gallery.dataset.count = order.length;
      }
      this.go(0, initial ? 'auto' : 'smooth');
    }
    go(i, behavior = 'smooth') {
      const n = this.visible.length;
      if (!n || !this.track) return;
      const idx = ((i % n) + n) % n;
      if (this.track.scrollWidth > this.track.clientWidth + 2) this.track.scrollTo({ left: this.visible[idx].offsetLeft, behavior });
      this.active(idx);
    }
    active(i) {
      this.index = i;
      this.visible.forEach((s, k) => { if (s._thumb) s._thumb.classList.toggle('is-active', k === i); });
      if (this.counter) this.counter.textContent = `${i + 1} / ${this.visible.length}`;
      const t = this.visible[i] && this.visible[i]._thumb;
      if (t && this.thumbs && this.thumbs.scrollHeight > this.thumbs.clientHeight) {
        const top = t.offsetTop - this.thumbs.offsetTop;
        if (top < this.thumbs.scrollTop || top + t.offsetHeight > this.thumbs.scrollTop + this.thumbs.clientHeight) this.thumbs.scrollTop = top - 10;
      }
    }
    options() {
      return $$('[data-option-index]', this.root)
        .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
        .map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
    }
    onChange() {
      const opts = this.options();
      this.current = this.data.variants.find((v) => v.options.every((o, i) => o === opts[i])) || null;
      $$('[data-option-index]', this.root).forEach((fs) => {
        const c = $('input:checked', fs);
        const label = $('[data-option-value]', fs);
        if (c && label) label.textContent = c.dataset.label || c.value;
      });
      this.render();
      this.filter(false);
      this.availability();
    }
    render() {
      const v = this.current;
      const buttons = $$('[data-add-button]', this.root);
      const price = $('[data-price]', this.root);
      const stock = $('[data-stock]', this.root);
      if (!v) {
        buttons.forEach((b) => { b.disabled = true; b.textContent = S.unavailable; });
        if (stock) { stock.className = 'stock stock--out'; stock.textContent = S.noCombo; }
        return;
      }
      if (this.idInput) this.idInput.value = v.id;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* bv. in een voorbeeldframe */ }
      if (price) price.innerHTML = priceHTML(v.price, v.compare, false);
      const save = $('[data-save]', this.root);
      if (save) {
        save.hidden = !(v.compare > v.price);
        if (!save.hidden) save.textContent = `Bespaar ${money(v.compare - v.price)}`;
      }
      const bundle = $('[data-bundle]', this.root);
      if (bundle) {
        const pct = Number(bundle.dataset.pct) || 0;
        const duo = v.price + Math.floor((v.price * (100 - pct)) / 100);
        const set = (sel, cents) => { const el = $(sel, bundle); if (el) el.textContent = money(cents); };
        set('[data-bundle-single]', v.price);
        set('[data-bundle-duo]', duo);
        set('[data-bundle-duo-full]', v.price * 2);
      }
      const bar = $('[data-stock-bar]', this.root);
      if (bar) {
        const known = v.qty !== null && v.qty <= 10;
        bar.style.width = `${known ? Math.max(v.qty, 0) * 10 : 100}%`;
        bar.parentElement.classList.toggle('is-full', !known);
      }
      buttons.forEach((b) => { b.disabled = !v.available; b.textContent = v.available ? S.addToCart : S.soldOut; });
      if (stock) {
        if (!v.available) { stock.className = 'stock stock--out'; stock.textContent = S.outOfStock; }
        else if (v.qty !== null && v.qty > 0 && v.qty <= 5) { stock.className = 'stock stock--low'; stock.textContent = S.lowStock.replace('[count]', v.qty); }
        else { stock.className = 'stock'; stock.textContent = S.inStock; }
      }
      this.updateSticky();
    }
    availability() {
      const opts = this.options();
      $$('[data-option-index]', this.root).forEach((fs) => {
        const idx = Number(fs.dataset.optionIndex);
        $$('[data-option-input]', fs).forEach((input) => {
          const test = opts.slice();
          test[idx] = input.value;
          const ok = this.data.variants.some((v) => v.available && v.options.every((o, i) => o === test[i]));
          const wrap = input.closest('.swatch, .pill');
          if (wrap) wrap.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    initSticky() {
      const main = $('[data-main-atc]', this.root);
      if (!this.sticky || !main) return;
      const footer = $('.site-footer');
      const update = () => {
        const passed = main.getBoundingClientRect().bottom < 0;
        const atFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        const show = passed && !atFooter;
        if (show !== this.sticky.classList.contains('is-visible')) {
          this.sticky.classList.toggle('is-visible', show);
          this.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        }
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      this.updateSticky();
    }
    updateSticky() {
      if (!this.sticky || !this.current) return;
      const v = this.current;
      const price = $('[data-sticky-price]', this.sticky);
      if (price) price.textContent = money(v.price);
      const label = $('[data-sticky-variant]', this.sticky);
      if (label) label.textContent = $$('[data-option-input]:checked', this.root).map((i) => i.dataset.label || i.value).join(' · ');
      const img = $('.sticky-buy__media img', this.sticky);
      if (img && v.image) { img.removeAttribute('srcset'); img.src = v.image; }
    }
  }

  let box;
  function lightbox(slides, start) {
    if (!slides.length) return;
    if (!box) {
      box = document.createElement('div');
      box.className = 'lightbox';
      box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Vergrote afbeelding');
      const ic = (d) => `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${d}"/></svg>`;
      box.innerHTML = `<img class="lightbox__img" alt=""><button type="button" class="lightbox__btn lightbox__close" aria-label="Sluiten">${ic('m5.5 5.5 13 13m0-13-13 13')}</button><button type="button" class="lightbox__btn lightbox__prev" aria-label="Vorige">${ic('m14.5 6-6 6 6 6')}</button><button type="button" class="lightbox__btn lightbox__next" aria-label="Volgende">${ic('m9.5 6 6 6-6 6')}</button>`;
      document.body.appendChild(box);
      box.addEventListener('click', (e) => {
        if (e.target.closest('.lightbox__prev')) { box.show(box.i - 1); return; }
        if (e.target.closest('.lightbox__next')) { box.show(box.i + 1); return; }
        close();
      });
      document.addEventListener('keydown', (e) => {
        if (!box.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') box.show(box.i - 1);
        if (e.key === 'ArrowRight') box.show(box.i + 1);
      });
    }
    function close() { box.classList.remove('is-open'); if (!layers.open) document.body.classList.remove('is-locked'); }
    box.slides = slides;
    box.classList.toggle('lightbox--single', slides.length < 2);
    box.show = (i) => { const n = box.slides.length; box.i = ((i % n) + n) % n; $('.lightbox__img', box).src = box.slides[box.i].dataset.zoom; };
    box.show(start < 0 ? 0 : start);
    box.classList.add('is-open');
    document.body.classList.add('is-locked');
    $('.lightbox__close', box).focus({ preventScroll: true });
  }

  $$('[data-product]').forEach((root) => new Product(root));
})();